import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Calendar from "../../../../../../../components/calendar/Calendar";
import styles from "../../../../InfoCliniche/InfoCliniche.module.css";
import Utils from "../../../../../../../utils/Utils";

class EsitoFollowUp extends Component {

    state = {
        EsitoFollowUp: {
            esito: "", 
            dataEsito: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia?.schedaSpeciale?.esitoFollowUp) {
            this.setState({
                EsitoFollowUp: {
                    ...this.state.EsitoFollowUp,
                    ...JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.esitoFollowUp)),
                    corretto: []
                }
            }, () => this.aggiornaPadre());
        } else if (this.props.segnalazioneCopia.esito) {
            const esitoObj = this.props.segnalazioneCopia.esito;
            const mappaEsito = {
                "19":  "Miglioramento",
                "20":  "Guarito",
                "21":  "Dimissioni",
                "22":  "Persistenza sintomi",
                "23":  "Decesso",
                "148":  "Non Noto",
                "148*": "Non Noto",
                "149": "Esiti Invalidanti",
                "152": "Decesso"
            };
            const esito     = mappaEsito[String(esitoObj.esito)] || "";
            const dataEsito = esitoObj.dataEsito
                ? Utils.formatDateISO(esitoObj.dataEsito, "/")
                : "";
            this.setState(prev => ({
                EsitoFollowUp: { ...prev.EsitoFollowUp, esito, dataEsito, corretto: [] }
            }), () => this.aggiornaPadre());
        } else {
            this.aggiornaPadre();
        }
    }

    // NUOVA LOGICA ROBUSTA
    riceviValore(arg1, arg2) {
        let esitoFollowUp = this.state.EsitoFollowUp;
        let field, valore;

        // Caso A: RadioButton o Input (field, event)
        if (typeof arg1 === "string" && arg2 && arg2.target) {
            field = arg1;
            valore = arg2.target.value;
        } 
        // Caso B: Calendar che invia (field, value)
        else if (typeof arg1 === "string" && (typeof arg2 === "string" || arg2 instanceof Date || arg2 === null)) {
            field = arg1;
            valore = arg2;
        }
        // Caso C: Fallback se il componente invia solo il valore (usiamo l'ID del componente come field)
        else if (arg1 && arg1.target) {
            field = arg1.target.id || arg1.target.name;
            valore = arg1.target.value;
        }

        if (field) {
            esitoFollowUp[field] = valore;
            if (field === "esito" && valore !== "Decesso") {
                esitoFollowUp.dataEsito = "";
            }
            this.setState({EsitoFollowUp: esitoFollowUp}, () => {
                this.aggiornaPadre();
            });
        } else {
            console.error("Impossibile determinare il campo da aggiornare", arg1, arg2);
        }
    }

    aggiornaPadre() {
        this.controlloCorrettezza();
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();
        
        let oggettoBE = this.createOggettoBE();
        if (this.props.setEsitoFollowUp) {
            this.props.setEsitoFollowUp(this.state.EsitoFollowUp, oggettoBE);
        }
    }

    controlloCorrettezza() {
        let dati = this.state.EsitoFollowUp;
        dati.corretto = [];
        // if (!dati.esito) dati.corretto[0] = "Campo Esito obbligatorio";
        // if (dati.esito === "Decesso" && !dati.dataEsito) dati.corretto[1] = "Data Decesso obbligatoria";
    }

    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.EsitoFollowUp));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    render() {
        const {t} = this.props;
        const {EsitoFollowUp: data} = this.state;
        const path = "SchedaSpecialeArbovirosi.EsitoFollowUp";

        const opzioniEsito = [
            { id: "guarito", val: "Guarito", text: `${path}.opzioni.guarito` },
            { id: "miglioramento", val: "Miglioramento", text: `${path}.opzioni.miglioramento` },
            { id: "grave", val: "Grave", text: `${path}.opzioni.grave` },
            { id: "deceduto", val: "Decesso", text: `${path}.opzioni.deceduto` },
            { id: "dimissioni", val: "Dimissioni", text: `${path}.opzioni.dimissioni` },
            { id: "esitiInvalidanti", val: "Esiti Invalidanti", text: `${path}.opzioni.esiti_invalidanti` },
            { id: "persistenzaSintomi", val: "Persistenza sintomi", text: `${path}.opzioni.persistenza_sintomi` },
            { id: "nonNoto", val: "Non Noto", text: `${path}.opzioni.non_noto` },
            { id: "nonApplicabile", val: "Non Applicabile", text: `${path}.opzioni.non_applicabile` },
            { id: "sintomiNat", val: "Comparsa di sintomi successiva a riscontro NAT positiva", text: `${path}.opzioni.sintomi_nat` }
        ];

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>
                <div className="row">
                    <div className="col-lg-2">
                        <p className={styles.labelHeader}>
                            <b>{t(`${path}.labelEsito`)}:</b>
                        </p>
                    </div>
                    <div className="col-lg-5">
                        {opzioniEsito.map((item) => (
                            <div key={item.id} style={{marginBottom: "8px"}}>
                                <RadioButton 
                                    id={item.id}
                                    name="esito" 
                                    label={t(item.text)}
                                    value={item.val}
                                    newRadio={true}
                                    onClick={this.riceviValore}
                                    checked={data.esito === item.val}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="col-lg-5">
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "#1b7ea9"
                            }}
                        >
                            {t(`${path}.labelData`)}</p>
                        <Calendar
                            id={"dataEsito"}
                            field={"dataEsito"}
                            value={data.dataEsito}
                            onChange={this.riceviValore}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(EsitoFollowUp);